// export const SYS_APi_TOKEN_URL = '/shopCoupon'
export const SYS_APi_SCREENING_URL = '/couponScreening'
// export const APP_NAME = "消费券信息采集平台";
// export const INTERTYPELIST =[{code:"WEB",value:"WEB"},{code:"API",value:"API"}];
//去除WEB接入方式
export const INTERTYPELIST =[{code:"API",value:"API"}];
